<template>
  <div v-show="instructionsStatus" class="instructions">
    <Subject name="math" />
    <div class="container">
      <div class="title">EXAMPLE</div>
      <div class="text">
        Solve the subtraction. Lean on the tens and ones by clicking on each of them to subtract and count the total.
        For each time you throw the clown you will earn 100 points. For example:
      </div>
      <button class="button">Hola</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import { Howl } from 'howler';
// import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Instructions',
  components: {
    Subject: () => import('@/components/practices/Subject.vue'),
  },
  computed: {
    ...mapGetters({
      instructionsStatus: 'clownToWater/instructionsStatus',
    }),
  },
  methods: {
    // ...mapActions({
    //   homeClickStart: 'clownToWater/homeClickStart',
    // }),
    // nextInstructions() {
    //   sounds.globalButton.play();
    //   if (this.animationActive) {
    //   } else {
    //     this.animationActive = true;
    //     if (this.instructionsPage <= 1) {
    //       this.pageOneIsOpen = false;
    //       this.pageTwoIsOpen = false;
    //       setTimeout(() => {
    //         this.instructionsPage += 1;
    //         this.pageOneIsOpen = true;
    //         this.pageTwoIsOpen = true;
    //         this.animationActive = false;
    //       }, 2000);
    //     }
    //     if (this.instructionsPage === 2) {
    //       this.pageOneIsOpen = false;
    //       this.animationActive = false;
    //       this.instructionsPage += 1;
    //     }
    //   }
    // },
    // resetLocalData() {
    //   this.animationActive = false;
    //   this.instructions = false;
    //   this.instructionsPage = 0;
    //   this.pageOneIsOpen = true;
    //   this.pageTwoIsOpen = true;
    // },
    // runInstructions() {
    //   sounds.globalButton.play();
    //   // this.instructions = true;
    //   console.log('Clicked instructions start button.');
    // },
    // startGame() {
    //   sounds.globalButton.play();
    //   this.pageOneIsOpen = false;
    //   this.pageTwoIsOpen = false;
    //   setTimeout(() => {
    //     this.resetLocalData();
    //     this.homeClickStart();
    //   }, 2000);
    // },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.instructions {
  @include flex-center;

  .container {
    @include flex-center;
    background-color: #f8f8f8;
    border: 0.4em solid #ac1818;
    border-radius: 75px;
    flex-direction: column;
    height: 80vh;
    position: relative;
    width: 80vw;

    * {
      text-align: center;
    }

    .title {
      font-family: Splatch, sans-serif;
      position: absolute;
      -webkit-text-stroke-color: #ffffff;
      -webkit-text-stroke-width: 0.05em;
      top: -0.75em;
    }

    .text {
      width: 95%;
    }

    .button {
      height: 1em;
    }
  }
}

// .home {
//   @include flex-center;
//   height: 100vh;
//   position: absolute;
//   width: 100vw;

//   .button--start {
//     bottom: 5vh;
//     height: 2em;
//     position: absolute;
//     right: 5vh;
//   }

//   .container {
//     @include flex-center;
//     background-color: #f8f8f8;
//     border: 0.4em solid #ac1818;
//     border-radius: 75px;
//     height: 60vh;
//     position: relative;
//     transform: perspective(60vw) rotateY(-15deg) translate(5vw, 0);
//     width: 60vw;
//   }

//   .title {
//     display: grid;
//     font-family: Splatch, sans-serif;
//     font-size: 3.5em;
//     grid-template:
//       'clown clown clown'
//       'to water none'
//       'drop-left water drop-right';
//     position: absolute;
//     right: 5%;
//     text-shadow: 0.05em 0.05em 10px #000000aa;
//     -webkit-text-stroke-color: #ffffff;
//     width: min-content;
//     z-index: 2;

//     * {
//       text-align: center;
//       padding: 0.2em;
//     }

//     &--clown {
//       color: #bfdb00;
//       grid-area: clown;
//       -webkit-text-stroke-width: 0.05em;
//     }

//     &--to {
//       color: #7c19c6;
//       font-size: 25%;
//       grid-area: to;
//       -webkit-text-stroke-width: 0.075em;
//     }

//     &--water {
//       font-size: 75%;
//       grid-area: water;
//       -webkit-text-stroke-width: 0.05em;
//     }

//     &--drop-left,
//     &--drop-right {
//       font-size: 25%;
//       height: 2.5em;
//     }

//     &--drop-left {
//       grid-area: drop-left;
//     }

//     &--drop-right {
//       grid-area: drop-right;
//     }
//   }

//   #clown-home {
//     height: 75vh;
//     position: absolute;
//     transform: translate(-30vw, 0);
//     width: 75vh;
//     z-index: 1;
//   }
// }

// @media (max-aspect-ratio: 8/5) {
//   .home {
//     .container {
//       height: 50vh;
//       transform: perspective(60vw) rotateY(-15deg) translate(7.5vw, 0);
//     }

//     .title {
//       font-size: 2.25em;
//     }
//   }
// }
</style>
